import { cn } from '../../lib/cn';
import type { RuleRow } from '../../unifiedcommerce/framework';

type Props = { rules?: RuleRow[] };

export function MarketplaceRulesPanel({ rules = [] }: Props) {
  return (
    <div className="space-y-2">
      {rules.map((r) => (
        <div key={r.rule} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{r.rule}</p>
            <p className="mt-0.5 text-xs text-slate-500">{r.marketplace}</p>
          </div>
          <div className="shrink-0 text-right">
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              r.violations === 0 ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300',
            )}>
              {r.violations} violations
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
